export default "__VITE_ASSET__Bb6V6KYV__"